import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UnsavedChangesModalService } from '../can-deactivate-guard/unsaved-changes-modal.service';

@Component({
  selector: 'app-close-modal',
  templateUrl: './close-modal.component.html',
  styleUrls: ['./close-modal.component.scss'],
})
export class CloseModalComponent implements OnInit {
  @Input() isInnerModal = false;
  @Output() closeModal = new EventEmitter<boolean>();

  modalButtons = {
    dismiss: 'Stay',
    apply: 'Leave',
  };

  constructor(private unsavedChangesModalService: UnsavedChangesModalService) {}


  ngOnInit() {
    this.unsavedChangesModalService.showModalEmitter.subscribe();
  }

  close(confirmation: boolean) {
    this.closeModal.emit(confirmation);
    this.unsavedChangesModalService.resolveDialog(confirmation);
  }
}
